/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PatientIssueValue } from './PatientIssueValue';
import {
    PatientIssueValueFromJSON,
    PatientIssueValueFromJSONTyped,
    PatientIssueValueToJSON,
} from './PatientIssueValue';

/**
 * 
 * @export
 * @interface PatientIssueHistory
 */
export interface PatientIssueHistory {
    /**
     * 
     * @type {number}
     * @memberof PatientIssueHistory
     */
    date: number;
    /**
     * 
     * @type {string}
     * @memberof PatientIssueHistory
     */
    author_role?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIssueHistory
     */
    author_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientIssueHistory
     */
    action: string;
    /**
     * 
     * @type {PatientIssueValue}
     * @memberof PatientIssueHistory
     */
    value: PatientIssueValue;
}

/**
 * Check if a given object implements the PatientIssueHistory interface.
 */
export function instanceOfPatientIssueHistory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function PatientIssueHistoryFromJSON(json: any): PatientIssueHistory {
    return PatientIssueHistoryFromJSONTyped(json, false);
}

export function PatientIssueHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientIssueHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': json['date'],
        'author_role': !exists(json, 'author_role') ? undefined : json['author_role'],
        'author_id': !exists(json, 'author_id') ? undefined : json['author_id'],
        'action': json['action'],
        'value': PatientIssueValueFromJSON(json['value']),
    };
}

export function PatientIssueHistoryToJSON(value?: PatientIssueHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'author_role': value.author_role,
        'author_id': value.author_id,
        'action': value.action,
        'value': PatientIssueValueToJSON(value.value),
    };
}

